import React from "react";
import {
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBIcon,
  MDBBadge,
  MDBRow,
  MDBCol,
} from "mdb-react-ui-kit";

export class BalanceByAccountCard extends React.Component {
  formatCurrency(value) {
    return new Intl.NumberFormat("es-ES", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 2,
    }).format(value ?? 0);
  }

  render() {
    const { personalAccounts = [] } = this.props;

    return (
      <MDBCard>
        <MDBCardBody>
          <MDBCardTitle className="dashboard-section-title">
            <MDBIcon fas icon="wallet" className="me-2" />
            Balance por cuenta
          </MDBCardTitle>
          {personalAccounts && personalAccounts.length > 0 ? (
            <div className="balance-account-list">
              {personalAccounts.map((account) => (
                <div key={account.IDCuenta} className="balance-account-row mb-3">
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <p className="mb-0 fw-bold">{account.nombre}</p>
                      <small className="text-muted">
                        {account.numTransacciones} transacción{account.numTransacciones !== 1 ? "es" : ""}
                      </small>
                    </div>
                    <div className="text-end">
                      <MDBBadge
                        color={account.saldo >= 0 ? "success" : "danger"}
                        pill
                        className="balance-account-badge"
                      >
                        {this.formatCurrency(account.saldo)}
                      </MDBBadge>
                      {!account.activo && (
                        <div className="mt-1">
                          <small className="badge bg-secondary">Inactiva</small>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-muted text-center py-3">No tienes cuentas personales.</p>
          )}
        </MDBCardBody>
      </MDBCard>
    );
  }
}
